import { render } from "./destinationDetailsModal.vue?vue&type=template&id=2007e0bd&scoped=true"
import script from "./destinationDetailsModal.vue?vue&type=script&lang=js"
export * from "./destinationDetailsModal.vue?vue&type=script&lang=js"

import "./destinationDetailsModal.vue?vue&type=style&index=0&id=2007e0bd&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2007e0bd"]])

export default __exports__